import React from 'react';
import I18n from '../../blocks/localization';
import { useHistory } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import icon_e_novcanik from '../../assets/icons/2x/icon_e-novcanik.png';
import RoutesConst from '../../blocks/consts/RoutesConst';
import ContentLayout from '../core/ContentLayout';
import { ResponseCode } from '../../models/order/ResponseCode';
import PrometInfoIconBox from '../shared/PrometInfoIconBox';

interface Props {
    responseCode: ResponseCode;
}

const EWalletTopUpInfo = (props: Props) => {

    const history = useHistory();

    const redirect = (route: string) => {
        history.push(route);
    }

    const getText = (): string => {
        switch (props.responseCode) {
            case ResponseCode.Ok:
                return I18n.t('eWalletTopUpInfo.successText');
            case ResponseCode.Canceled:
                return I18n.t('eWalletTopUpInfo.cancelText');
            case ResponseCode.Error:
                return I18n.t('eWalletTopUpInfo.errorText');
        }
    }

    return (
        <ContentLayout titleTranslateId='eWalletTopUpInfo.title'>
            <PrometInfoIconBox icon={icon_e_novcanik} content={getText()} />

            <Row>
                <Col xl={12}>
                    <Button type="button" color="primary" className="mr-3 mb-3" outline onClick={() => redirect(RoutesConst.Home)}>{I18n.t('eWalletTopUpInfo.returnToHome')}</Button>
                    {
                        props.responseCode !== ResponseCode.Ok &&
                        <Button type="button" color="primary" className='mb-3' outline onClick={() => redirect(RoutesConst.EWallet)}>{I18n.t('eWalletTopUpInfo.tryAgain')}</Button>
                    }
                </Col>
            </Row>
        </ContentLayout>
    );
}

export default EWalletTopUpInfo;
